module.exports = require("external-editor");


//////////////////
// WEBPACK FOOTER
// external "external-editor"
// module id = 80
// module chunks = 0